import { createReducer, on } from '@ngrx/store';
import { FlightFinderInitState } from '../models/flight-finder.interface';
import * as FlightFinderActions from './flight-finder.action';

// Initial State
const initState: FlightFinderInitState = {
  quoteFlightRequest: {
    departureAirport: null,
    toAirport: null,
    toCity: null,
    arrivalAirport: null,
    fromAirport: null,
    fromCity: null,
    airline: null,
    airlineName: null,
    departDate: null,
    bagCount: null,
    bagItems: {
      bags: 0,
      childEquipment: 0,
      oversizeItem: 0
    },
    flightDirection: null,
    flightNumber: null
  },
  quoteFlightResults: [],
  quoteFlightCacheRequest: null,
  paginationFlightResponse: null,
  flightConnectionCount: 0,
  requestCount: 0,
  requestLegs: 0,
  searchMultiLegApi: false,
  filterLegs: {
    direct: true,
    oneStop: false,
    twoStop: false
  },
  userHasSelected: false,
  datalinkError: false,
  dataLinkSession: null,
  redirectToSearch: false,
  flightNumberSearchRequest: null,
  flightNumberSearchResult: [],
  sessionUsed: false,
  selectedMultiLegFlight: null,
  returnSessionString: null,
  returnSessionId: null,
  returnCustomerUrl: '',
  promoFromUrl: null,
  productTierFromUrl: null,
  csMotoFromUrl: false,
  selectedProductType: '',
  locationData: null,
  isSbbSubsidyApplied: false,
  isSbbSubsidyApplicable: false,
  postcodeForPricing: null,
  zoneInfo: null,
  locationInitialised: false,
  airlineSearchString: ''
};

// Reducer
export const flightFinderReducer = createReducer(
  initState,
  on(FlightFinderActions.updateFlightQuoteData, (state, { payload }) => ({
    ...state,
    quoteFlightRequest: payload
  })),
  on(FlightFinderActions.updateFlightQuoteCacheRequest, (state, { payload }) => ({
    ...state,
    quoteFlightCacheRequest: payload
  })),
  on(FlightFinderActions.updateFlightQuoteResults, (state, { payload }) => ({
    ...state,
    quoteFlightResults: payload
  })),
  on(FlightFinderActions.updatePaginationData, (state, { payload }) => ({
    ...state,
    paginationFlightResponse: payload
  })),
  on(FlightFinderActions.updateFlightConnectionCount, (state, { payload }) => ({
    ...state,
    flightConnectionCount: payload
  })),
  on(FlightFinderActions.incrementRequestCount, (state) => ({
    ...state,
    requestCount: state.requestCount + 1
  })),
  on(FlightFinderActions.setRequestCount, (state, { payload }) => ({
    ...state,
    requestCount: payload
  })),
  on(FlightFinderActions.setRequestLegs, (state, { payload }) => ({
    ...state,
    requestLegs: payload
  })),
  on(FlightFinderActions.updateApiSearch, (state, { payload }) => ({
    ...state,
    searchMultiLegApi: payload
  })),
  on(FlightFinderActions.updateFilterLegs, (state, { payload }) => ({
    ...state,
    filterLegs: payload
  })),
  on(FlightFinderActions.updateUserSelected, (state, { payload }) => ({
    ...state,
    userHasSelected: payload
  })),
  on(FlightFinderActions.updateDatalinkSession, (state, { payload }) => ({
    ...state,
    dataLinkSession: payload
  })),
  on(FlightFinderActions.updateDatalinkError, (state, { payload }) => ({
    ...state,
    datalinkError: payload
  })),
  on(FlightFinderActions.updateFlightNumberRequest, (state, { payload }) => ({
    ...state,
    flightNumberSearchRequest: payload
  })),
  on(FlightFinderActions.updateFlightNumberResult, (state, { payload }) => ({
    ...state,
    flightNumberSearchResult: payload
  })),
  on(FlightFinderActions.updateRedirectToSearch, (state, { payload }) => ({
    ...state,
    redirectToSearch: payload
  })),
  on(FlightFinderActions.updateSessionUsed, (state, { payload }) => ({
    ...state,
    sessionUsed: payload
  })),
  on(FlightFinderActions.updateSelectedMultiLegFlight, (state, { payload }) => ({
    ...state,
    selectedMultiLegFlight: payload
  })),
  on(FlightFinderActions.updateReturnSessionString, (state, { payload }) => ({
    ...state,
    returnSessionString: payload
  })),
  on(FlightFinderActions.updateReturnSessionId, (state, { payload }) => ({
    ...state,
    returnSessionId: payload
  })),
  on(FlightFinderActions.updateReturnCustomerUrl, (state, { payload }) => ({
    ...state,
    returnCustomerUrl: payload
  })),
  on(FlightFinderActions.updatePromoFromUrl, (state, { payload }) => ({
    ...state,
    promoFromUrl: payload
  })),
  on(FlightFinderActions.updateProductTierFromUrl, (state, { payload }) => ({
    ...state,
    productTierFromUrl: payload
  })),
  on(FlightFinderActions.updateCsMotoFromUrl, (state, { payload }) => ({
    ...state,
    csMotoFromUrl: payload
  })),
  on(FlightFinderActions.updateAirlineSearchString, (state, { payload }) => ({
    ...state,
    airlineSearchString: payload
  })),
  on(FlightFinderActions.resetFilterLegs, (state) => ({
    ...state,
    filterLegs: initState.filterLegs
  })),
  on(FlightFinderActions.resetFlightQuoteData, (state) => ({
    ...state,
    quoteFlightRequest: initState.quoteFlightRequest
  })),
  on(FlightFinderActions.resetFlightQuoteResults, (state) => ({
    ...state,
    quoteFlightResults: initState.quoteFlightResults
  })),
  on(FlightFinderActions.resetSelectedMultiLegFlight, (state) => ({
    ...state,
    selectedMultiLegFlight: null
  })),
  on(FlightFinderActions.refreshFlightFinder, (state, { payload }) => ({
    ...payload,
    requestCount: 0
  })),
  on(FlightFinderActions.resetFlightFinder, () => initState)
);
